
import React from "react";
import "./pagestyles/TermsofService.css";


const TermsOfService = () => {
  return (
    <>
      <div className="tos-container">

        {/* Header */}
        <div className="tos-header">
          <h1>Terms of Service</h1>
          <p>Last Updated: March 2026</p>
        </div>

        {/* Content */}
        <div className="tos-content">

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using this website, you agree to be bound by these
              Terms of Service. If you do not agree with any part of these terms,
              you may not access the website.
            </p>
          </section>

          <section>
            <h2>2. Use of Content</h2>
            <p>
              All content published on this website, including articles, data,
              graphics, logos, and software, is the property of Redbox Global or
              its licensors and is protected by copyright and intellectual
              property laws.
            </p>
            <p>
              You may not reproduce, distribute, modify, publish, transmit, or
              otherwise exploit any material from this website without prior
              written permission.
            </p>
          </section>

          <section>
            <h2>3. Information Disclaimer</h2>
            <p>
              The information provided on this website is for informational
              purposes only and should not be considered financial, legal, or
              investment advice. While we strive to keep information accurate
              and up to date, we do not guarantee the accuracy, reliability,
              or completeness of any information.
            </p>
          </section>

          <section>
            <h2>4. User Accounts</h2>
            <p>
              Certain features of the website may require user registration.
              You agree to provide accurate and complete information and to
              keep your login credentials confidential.
            </p>
            <p>
              You are responsible for all activities that occur under your
              account.
            </p>
          </section>

          <section>
            <h2>5. Subscription and Payments</h2>
            <p>
              Some services offered on this website may require a paid
              subscription. Subscription fees are billed on a recurring basis
              according to the plan selected by the user.
            </p>
            <p>
              You may cancel your subscription at any time before the next
              billing cycle to avoid additional charges.
            </p>
          </section>

          <section>
            <h2>6. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites or services
              that are not owned or controlled by Redbox Global.
            </p>
            <p>
              We are not responsible for the content, policies, or practices
              of any third-party websites.
            </p>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>
              Redbox Global shall not be liable for any direct, indirect,
              incidental, consequential, or special damages arising from your
              use of or inability to use the website.
            </p>
          </section>

          <section>
            <h2>8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms of Service at any time.
              Updates will be posted on this page and the revised date will be
              updated accordingly.
            </p>
            <p>
              Continued use of the website after such changes constitutes
              acceptance of the revised terms.
            </p>
          </section>

          <section>
            <h2>9. Governing Law</h2>
            <p>
              These Terms of Service shall be governed by and interpreted in
              accordance with the laws of the applicable jurisdiction.
            </p>
          </section>

          <section>
            <h2>10. Contact Information</h2>
            <p>
              If you have any questions regarding these Terms of Service,
              please contact us at:
            </p>
            <p>
              <strong>Email:</strong> support@redboxglobal.com
            </p>
          </section>

        </div>
      </div>

      
    </>
  );
};

export default TermsOfService;